import { ContainerModule } from 'inversify';

import { RestrictionsFacade } from './facade/restrictions.facade';
import { RestrictionsRepository } from './repositories/restrictions.repository';
import { TYPES } from './restrictions.types';
import { RestrictionsService } from './services/restrictions.service';
import { RestrictionsStoreInjector, useRestrictionsStore } from './store/restrictions.store';

export const restrictionsModule = new ContainerModule((bind) => {
  bind<RestrictionsStoreInjector>(TYPES.RestrictionsStore).toConstantValue(useRestrictionsStore);

  bind(TYPES.RestrictionsFacade).to(RestrictionsFacade).inSingletonScope();
  bind(TYPES.RestrictionsRepository).to(RestrictionsRepository).inSingletonScope();

  bind(TYPES.RestrictionsService).to(RestrictionsService).inSingletonScope();
});
